const AceOcnResponseApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/response/getAceOceanResponse`,
  GET_SN: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/response/getAceOceanSNResponse`,
};

export default AceOcnResponseApiUrls
